import { useEffect, useRef, useState } from 'react';

// Long enough to see the title struck through before the row leaves
const STRIKE_MS = 450;

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

// Checking a row off strikes its title first, then marks the card done, so the row does not vanish under the pointer.
// A second click while it strikes does nothing. Once the press settles, a row still on screen clears its strike, so a
// check that did not go through can be tried again; a done card shows its done state on its own
export const useRowCheck = (onCheck: (() => unknown) | undefined) => {
  const [checking, setChecking] = useState(false);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const check = onCheck
    ? () => {
        if (checking) return;
        setChecking(true);
        window.setTimeout(
          () => {
            void Promise.resolve()
              .then(onCheck)
              .catch(() => undefined)
              .finally(() => {
                if (mounted.current) setChecking(false);
              });
          },
          prefersReducedMotion() ? 0 : STRIKE_MS
        );
      }
    : undefined;
  return { checking, check };
};
